'use client'
import { Common, dynamic, RingBuilder } from '@/config/NextImport'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
const ProductPrice = dynamic(() => import('@/components/common/ProductPrice'))
const WishlistIcon = dynamic(() => import('@/components/common/WishlistIcon'), {
  ssr: false,
  loading: () => {
    return (
      <img
        src={Common.setImagePath('assets/images/icon/wishlist.svg')}
        alt="wishlist-icon"
      />
    )
  }
})

const SettingItem = (props: any) => {
  const pathname = usePathname()
  const item = {
    ...props.item,
    url:
      pathname +
      '/' +
      props.item.name.toLowerCase().replaceAll(' ', '-') +
      '-sku-' +
      props.item.sku,
    url_param: '/' + props.item.name.toLowerCase().replaceAll(' ', '-') + '-sku-' + props.item.sku
  }
  const handleClick = (data: any, url: string) => {
    const storageSteps: any = RingBuilder.getRingBuilder()
    storageSteps.map((step: any) => {
      if (step.IsActive) {
        if (step.IsCompleted === false) {
          step.detail_url = url
        }
        step.url = Common.GetPathname()
        step.recent_url = Common.GetFullURL()
      }
      return true
    })
    RingBuilder.setRingBuilder(storageSteps)
    Common.setLinkClick(data.sku, data.url)
  }

  return (
    <>
      <div className={'col-6 col-md-6 col-lg-4 col-xl-3 product-listing-repeat ' + item.id}>
        <div className="product-listing-box">
          <div
            className={
              item?.category_ids?.some((x: any) => x === 317) ||
              item?.category_ids?.some((x: any) => x === 373)
                ? 'product-listing-img product-listing-new-img'
                : 'product-listing-img'
            }
          >
            <Link
              href={item.url}
              className="product-listing-img-link"
              onClick={() => handleClick(item, item.url)}
            >
              <img
                src={item.base_image}
                alt={item.name}
              />
            </Link>
          </div>
          <div className="product-listing-detail">
            <div className="product-listing-detail-title">
              <Link
                href={item.url}
                className="product-listing-detail-title-link"
                onClick={() => handleClick(item, item.url)}
              >
                <span>{Common.toTitleCase(item.name)}</span>
              </Link>
            </div>
            <div className="product-listing-detail-price">
              <ProductPrice data={item} />
            </div>
            <div className="product-listing-top-detail">
              <div className="product-listing-wishlist">
                <WishlistIcon item={item} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default SettingItem
